import TaskTypes from 'src/enums/TaskTypes'

const taskTypeToIntMap = {
  [TaskTypes.WATCH_VIDEO]: 'watch-video',
  [TaskTypes.OPERATIONAL]: 'operation',
  [TaskTypes.GOVERNANCE]: 'governance',
}

export default taskTypeToIntMap
